module.exports = __webpack_public_path__ + "static/forest-path-8d0477b3c492f3318a08e56272ae0835.jpeg";